import { ActionIcon, ActionIconProps, ActionIconVariant } from '@mantine/core';
import { HTMLAttributes, forwardRef } from 'react';

import classNames from './ActionIcon.module.scss';

/**
 * @deprecated Use `ActionIconProps` from `@zorro/design-system/v2/ActionIcon` instead.
 */
export type IActionIconProps = Omit<ActionIconProps, 'radius'> &
  HTMLAttributes<HTMLButtonElement> & {
    isChecked?: boolean;
    isTransparent?: boolean;
    isOnColor?: boolean;
    isDisableHover?: boolean;
    variant?: ActionIconVariant | 'filled' | 'hollow';
  };

/**
 * @deprecated Use `ActionIcon` from `@zorro/design-system/v2/ActionIcon` instead.
 */
export const ZorroActionIcon = forwardRef<HTMLButtonElement, IActionIconProps>(
  (
    {
      disabled = false,
      onClick,
      isChecked = false,
      size = 'lg',
      isTransparent = false,
      isOnColor = false,
      color = 'var(--mantine-color-zorroCoal-9)',
      isDisableHover = false,
      ...props
    },
    ref
  ) => {
    const handleClick = (
      event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
      if (!disabled && onClick) {
        onClick(event);
      }
    };

    return (
      <ActionIcon
        ref={ref}
        size={size}
        classNames={classNames}
        data-checked={isChecked}
        data-disabled={disabled}
        data-transparent={isTransparent}
        data-oncolor={isOnColor}
        data-disable-hover={isDisableHover}
        style={{ '--ai-color': color }}
        {...props}
        onClick={handleClick}
      />
    );
  }
);

ZorroActionIcon.displayName = 'ZorroActionIcon';
